import axios from "axios";
import React, { useEffect } from "react";
import OtpInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";


import { useLocalStorage } from "../../hooks";
import * as userActions from "../../redux/reducers/userReducer";
import { userState } from "../../redux/reducers/userReducer";

import BZLogo from "../../components/BZLogo";
import { TwButton, TwFormHelperText, TwMainLayout } from "../../components/tailwind";
import { classNames } from "../../helpers";
import { useToast } from "../../provider/ToastProvider";
import { loadingState, setActionLoading } from "../../redux/reducers/loadingReducer";
import { getUrlForServices, getUrlForUsers } from "../../utils/confighelpers";
import { OnBordingBaseLayout } from "../signup/onbording";
import { useTranslation } from "react-i18next";

export default function VerifyNumber({ }) {
  const { t, i18n } = useTranslation();
  const { addToast, addSuccessToast, addErrorToast, addNotificationDialog } = useToast();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loadingReduxState = useSelector(loadingState);
  const userReduxState = useSelector(userState);
  const [userToken] = useLocalStorage("userToken");
  const [onBoardingState, setOnBoardingState] = React.useState(
    userReduxState && userReduxState.onBoardingData && Object.keys(userReduxState.onBoardingData).length > 0 ? userReduxState.onBoardingData : (location.state !== null ? location.state : null)
  );
  const [otp, setOtp] = React.useState("");
  const [submitting, setSubmitting] = React.useState(false);
  const [resendSMSSubmitting, setResendSMSSubmitting] = React.useState(true);
  const [formErrors, setFormErrors] = React.useState({});
  const [numberToken, setNumberToken] = React.useState(
    // location?.state?.response?.data?.token
    onBoardingState?.response?.data?.token
  );
  const [, setUserToken] = useLocalStorage("userToken", "");
  const [loading, setLoading] = React.useState(false);

  const handleChange = (otp) => setOtp(otp);

  const handleWrongNumber = () => {
    let returnUrl = "/signup";
    if (
      onBoardingState?.socialType &&
      onBoardingState.socialType !== "normal"
    ) {
      returnUrl = "/on-bording";
    }
    navigate(returnUrl, {
      state: {
        profilePic: onBoardingState?.profilePic,
        countryName: onBoardingState?.countryName,
        number: onBoardingState?.number,
        formattedPhoneNumber: onBoardingState?.formattedPhoneNumber,
        fullName: onBoardingState?.fullName,
        password: onBoardingState?.password,
        ...onBoardingState,
      },
    });
  };

  const handleResendSMS = async () => {
    setResendSMSSubmitting(true);
    dispatch(setActionLoading(true));
    let config2 = {
      method: "post",
      url: `${getUrlForUsers()}registration`,
      data: {
        countryCode: onBoardingState.countryCode,
        phoneNumber: onBoardingState.number,
        socialType: "normal",
        userType: "teacher",
      },
    };
    if (
      onBoardingState?.socialType &&
      onBoardingState.socialType !== "normal"
    ) {
      config2 = {
        method: "put",
        url: `${getUrlForUsers()}updateProfile`,
        headers: {
          "x-access-token": userToken.toString(),
        },
        data: {
          countryCode: onBoardingState.countryCode,
          phoneNumber: onBoardingState.phone,
        },
      };
    }
    const request = await axios(config2);
    dispatch(setActionLoading(false));
    if (request.status === 200) {
      if (request.data.statusCode === 500) {
        addErrorToast(request.data.message);
        setResendSMSSubmitting(false);
        return;
      }
      setResendSMSSubmitting(false);
      setNumberToken(request.data.data.token);
      // addSuccessToast(t("successes.success"));
    } else {
      addErrorToast(t("signup.errorOopsSignup"));
      setResendSMSSubmitting(false);
    }
  };

  const handleSubmit = async () => {
    const errors = {};
    if (otp === "") {
      errors.otp = t("errors.required");
    }
    setFormErrors({ ...errors });
    if (Object.keys(errors).length > 0) {
      addErrorToast(t("errors.validationGeneralError"), { hideAfter: 3 });
      return;
    }
    setSubmitting(true);
    dispatch(setActionLoading(true));
    const body1 = {
      code: otp,
      token: numberToken,
    };
    const requestOtpVerification = await axios.post(
      `${getUrlForUsers()}verifyOtp`,
      body1
    );
    dispatch(setActionLoading(false));
    if (requestOtpVerification.status === 200) {
      if (requestOtpVerification.data.statusCode === 500) {
        addErrorToast(requestOtpVerification.data.message);
        setSubmitting(false);
        setFormErrors({ otp: t("errors.incorrectCode") });
        return;
      } else if (requestOtpVerification.data.statusCode === 201) {
        addErrorToast(requestOtpVerification.data.message);
        setSubmitting(false);
        setFormErrors({ otp: requestOtpVerification.data.message });
        return;
      }

      if (onBoardingState !== null && onBoardingState?.socialType && onBoardingState.socialType !== "normal") {
        navigate("/on-bording", {});
        return;
      } else {
        const { fullName, password, profilePic, socialType } = onBoardingState;
        const body2 = {
          fullName: fullName,
          password,
          profilePic: profilePic,
          deviceType: "Web",
          token: requestOtpVerification.data.data.token,
          appToken: "tgdXUkmSARLj5txmsd8wY2u8kFXavQXG",
          businessType: "event",
        };
        dispatch(setActionLoading(true));
        const requestUpdateLoginDetail = await axios.post(
          `${getUrlForUsers()}updateLoginDetail`,
          body2
        );
        dispatch(setActionLoading(false));
        if (requestUpdateLoginDetail.status === 200) {
          if (requestUpdateLoginDetail.data.statusCode === 200) {
            dispatch(userActions.setOnBoardingData(requestUpdateLoginDetail.data.data));
            dispatch(
              userActions.setUserData(requestUpdateLoginDetail.data.data)
            );
            dispatch(
              userActions.setUserPhone(onBoardingState.formattedPhoneNumber)
            );
            setUserToken(requestUpdateLoginDetail.data.data.token);
            addNotificationDialog({
              dialogType: "success",
              dialogTitle: t("signup.signupSuccessTitle"),
              dialogMessage: t("signup.signupSuccessSubTitle"),
              dialogBtnTitle: t("inputFieldsTitle.continue"),
              dialogBackdropClick: async () => {
                window.location.href = "/on-bording";
              },
              dialogBtnClick: async () => {
                window.location.href = "/on-bording";
              }
            })
          }
        } else {
          addErrorToast(t("signup.errorOopsSignup"));
          setSubmitting(false);
        }
      }
    } else {
      addErrorToast(t("signup.errorOopsSignup"));
      setSubmitting(false);
    }
  };

  const handleAddVenue = async (body) => {

    // }
    // }
    const payloadBody = {
      ...body,
    };
    let config = {
      method: "post",
      url: `${getUrlForServices()}venue/add`,
      headers: {
        "x-access-token": userToken,
      },
      data: payloadBody,
    };
    // setLoading(true)
    const request = await axios(config);
    // setLoading(false)
    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        // }
      } else {
        addErrorToast(request.data.message);
      }
    }
  };

  // TODO: Uncomment in prod
  // if (onBoardingState === null) {
  //   navigate("/signup");
  // }
  useEffect(() => {
    setTimeout(() => {
      setResendSMSSubmitting(false)
    }, 15 * 1000);

    return () => {
    }
  }, [])


  return (
    <TwMainLayout fullScreen={true} checkSession={false}>
      <OnBordingBaseLayout
        title={<BZLogo className={"!max-h-12 h-auto sm:!w-auto"} />}
        logoutCallBack={() => { }}
      >
        <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
          <div className={"grid grid-cols-1 items-center"}>
            {/* <img
              className={"pt-16 hidden md:flex md:w-full 1md:h-full"}
              src={undraw_vector}
              alt={"vector"}
            /> */}
            <div className={"flex flex-col gap-2 justify-center items-center"}>
              <h4
                className={
                  "text-3xl md:text-3xl lg:text-4xl pb-3 md:pb-1 font-bold"
                }
              >
                {t("forgotPassword.verifyForgotTitle")}
              </h4>
              <div className={"text-center"}>
                <p className={"sm:text-sm md:text-sm"}>
                  {t("forgotPassword.verifyForgotSubTitle1")}<br />
                  <span className="text-primary">
                    {onBoardingState.formattedPhoneNumber}
                  </span>
                  {t("forgotPassword.verifyForgotSubTitle2")}
                </p>
              </div>
              <OtpInput
                value={otp}
                onChange={handleChange}
                numInputs={4}
                containerStyle={`flex gap-3 justify-center my-4 md:my-6 lg:my-8`}
                inputStyle={classNames(`!size-16 text-sm/6 text-gray-900 placeholder:text-gray-400 sm:text-base disabled:bg-gray-200 rounded-xl bg-input-bz outline outline-1 -outline-offset-1 outline-gray-300 hover-within:outline hover-within:outline-2 hover-within:-outline-offset-2 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2`,
                  formErrors.otp ? "text-red-900 outline-red-300 placeholder:text-red-300 focus-within:outline-red-600"
                    : "text-gray-900 outline-gray-300 placeholder:text-gray-400 hover:outline-indigo-bz focus-within:outline-indigo-bz"
                )}
                renderInput={(props) => <input {...props} />}
                hasErrored={formErrors.otp}
                shouldAutoFocus
                inputType="number"
              />
              {formErrors.otp && (
                <TwFormHelperText
                  error={formErrors.otp}
                >
                  {formErrors.otp}
                </TwFormHelperText>
              )}
              <p
                className={
                  "flex flex-row justify-center items-center text-base sm:text-sm md:text-sm"
                }
              >
                {t("forgotPassword.verifyResendTitle")}&nbsp;
                <button
                  type="button"
                  className={
                    "text-indigo-bz disabled:text-indigo-bz/30 font-bold transition-opacity active:opacity-50 text-base sm:text-sm md:text-sm"
                  }
                  onClick={handleResendSMS}
                  disabled={resendSMSSubmitting}
                >
                  {t("inputFieldsTitle.resendSms")}
                </button>
              </p>
              <div className={"-mt-2 mb-4"}>
                <button
                  type="button"
                  className={
                    "text-center text-base sm:text-sm md:text-sm text-danger font-bold transition-opacity active:opacity-50"
                  }
                  onClick={handleWrongNumber}
                >
                  {t("inputFieldsTitle.wrongNumber")}
                </button>
              </div>
              <TwButton
                variant={"secondary"}
                disabled={loadingReduxState.actionLoading || submitting}
                actionLoading={(loadingReduxState.actionLoading)}
                className="w-full sm:w-auto sm:min-w-72  xs:text-base sm:text-xl md:py-3.5"
                onClick={handleSubmit}
              >
                {t("inputFieldsTitle.verifyNumber")}
              </TwButton>
              <p className={"text-center mt-6 sm:text-sm sm:mx-2 md:text-sm max-w-md"}>
                {t("linkDescription.tnpLine1")}
                <a
                  className={"inline-block"}
                  style={{ color: "gray", textDecoration: "underline" }}
                  href={"https://www.tikitly.com/terms-conditions.html"}
                  target="_blank" rel="noreferrer"
                >
                  {t("linkDescription.tnpTermsOfUse")}
                </a>{" "}
                {t("linkDescription.tnpLine2")}
                <a
                  className={"inline-block"}
                  style={{ color: "gray", textDecoration: "underline" }}
                  href={"https://www.tikitly.com/privacy-policy.html"}
                  target="_blank" rel="noreferrer"
                >
                  {t("linkDescription.tnpPrivacyPolicy")}
                </a>
              </p>
            </div>
          </div>
        </div>
      </OnBordingBaseLayout>
    </TwMainLayout>
  );
}
